/**
 * Input Schema of RelatorioGeracao
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {RelatorioGeracao} from '@/model/resource/RelatorioGeracao'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'
import {TipoRelatorioCollection} from '@/model/collection/TipoRelatorioCollection'

/* TODO: review generated schema */
export class InputRelatorioGeracaoSchema extends Schema {
  collectionResponsavel = new ResponsavelCollection().noPagination()
  collectionTipoRelatorio = new TipoRelatorioCollection().noPagination()

  readonly name = 'InputRelatorioGeracao'

  readonly fieldSet: FieldSet<RelatorioGeracao> = {
    responsavel: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionResponsavel.all(),
      },
    }),
    tipoRelatorio: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionTipoRelatorio.all(),
      },
    }),
    dataCriacao: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'datetime',
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    urlDownload: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 500,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    dataGeracaoRelatorio: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'datetime',
        label: this.translateFrom(schema.fieldName),
      },
    }),
  }
}
